import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { TooltipProvider } from "@pushpress/pushpress-ui";
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import Dashboard from "../../layouts/Dashboard";
import { PeopleManagement } from "./components/PeopleManagement";
import { PEOPLE_TYPE } from "./types";

export default function App() {
  const { path } = useRouteMatch("/people");
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    // redirect to "members" if user is at /people path or invalid subpath
    if (
      (pathname === "/people" || pathname.startsWith("/people/")) &&
      !pathname.endsWith("/members") &&
      !pathname.endsWith("/leads") &&
      !pathname.endsWith("/staff")
    ) {
      history.replace(`${path}/members`);
    }
  }, [history, path, location.pathname]);

  return (
    <>
      <TooltipProvider delayDuration={200}>
        <Helmet>
          <title>Your People</title>
        </Helmet>
        <Dashboard scrollableContent disableContentPadding>
          <Switch>
            <Route
              path={`${path}/${PEOPLE_TYPE.MEMBERS}`}
              component={() => (
                <PeopleManagement currentTab={PEOPLE_TYPE.MEMBERS} />
              )}
            />
            <Route
              path={`${path}/${PEOPLE_TYPE.LEADS}`}
              component={() => (
                <PeopleManagement currentTab={PEOPLE_TYPE.LEADS} />
              )}
            />
            <Route
              path={`${path}/${PEOPLE_TYPE.STAFF}`}
              component={() => (
                <PeopleManagement currentTab={PEOPLE_TYPE.STAFF} />
              )}
            />
          </Switch>
        </Dashboard>
      </TooltipProvider>
    </>
  );
}
